/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect} from 'react';
import {Dimensions, ScrollView, Text, View} from 'react-native';
import {connect} from 'react-redux';
import {separateurMillier} from '../../../../../../common/utils/rendering';
import {
  pensionPrimary,
  pensionSecondary,
} from '../../../../../../data/constants/Assurance/assuranceRetraite';
import {StackParams} from '../../../../../../data/types/navigation';
import mapDispatchToProps from '../../../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../../../services/redux/mapStateToProps';
import {buttonsStyles} from '../../../../../components/Button/boutonStyle';
import Button from '../../../../../components/Button/PrimaryButton';
import {Container} from '../../../../../components/Container';
import {HeaderScreen} from '../../../../../components/Header/HeaderScreen';
import {formsStyles} from '../../../../../components/Inputs/formStyles';
import Label from '../../../../../components/Label';
import styles from '../styles';

const windowHeight = Dimensions.get('window').height;
type NavigationProps = StackNavigationProp<StackParams, 'ResultatPension'>;
interface Info {
  trimestriel: string;
  capital: string;
}
const FResultatPension = (props: any) => {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const {dateNaissance, premierVersement} = props.route.params;
  console.log(premierVersement);

  const info: Info = {
    trimestriel: '',
    capital: '',
  };
  const {typeassurance, user, modeVersementUser} = props;
  if (typeassurance && typeassurance.data) {
    const trimestriel = typeassurance.data.trimestriel;
    const capital = typeassurance.data.capital;

    info.trimestriel = trimestriel && separateurMillier(trimestriel.toFixed(2));
    info.capital = capital && separateurMillier(capital.toFixed(2));
  }

  const handleSubmit = () => {
    user && user.data && user.data.utilisateur
      ? navigate('SouscriptionAssuranceRetraiteForm', {
          dateNaissance: dateNaissance,
          premierVersement: premierVersement,
        })
      : navigate('Login', {
          data: 'SouscriptionAssuranceRetraiteForm',
          montant: premierVersement,
          age: dateNaissance,
          isSimulation: true,
        });
  };
  useEffect(() => {
    modeVersementUser('Tous les mois', () => {});
  }, []);

  return (
    <Container>
      <HeaderScreen
        type="retour"
        title="Demander Simulation"
        noBreadcrumb={false}
      />
      <ScrollView>
        <View style={[formsStyles.webformContain]}>
          <View
            style={[
              formsStyles.formContain,
              {minHeight: windowHeight - 80, backgroundColor: '#fff'},
            ]}>
            <Label title="SIMULATION ASSURANCE RETRAITE" type="mainTitle" />
            <Label type="paragraph" title={pensionSecondary} />
            <View style={styles.containerResponse}>
              <View style={styles.cornerResponse}>
                <Text style={styles.txtGreen}>{info.trimestriel} Ar</Text>
              </View>
            </View>
            <Label type="paragraph" title={pensionPrimary} />
            <View style={styles.containerResponse}>
              <View style={styles.cornerInResponse}>
                <Text style={styles.txtBlack}>{info.capital} Ar</Text>
              </View>
            </View>

            <View style={buttonsStyles.displayCenter}>
              <View style={buttonsStyles.displayHorizontal}>
                <Button
                  onPress={() => {
                    goBack();
                  }}
                  styleBtnTxt={buttonsStyles.btnAnnuler}
                  styleBtnOuter={buttonsStyles.btnAnnulerOuterSimu}
                  title="Annuler"
                  type="annuler"
                />
                <Button
                  onPress={handleSubmit}
                  styleBtnTxt={buttonsStyles.btnValider}
                  styleBtnOuter={buttonsStyles.btnValiderOuterSimu}
                  title="Souscrire"
                  type="valider"
                />
              </View>
            </View>
          </View>
        </View>
      </ScrollView>
    </Container>
  );
};

export const ResultatSimulationPension: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FResultatPension);
